import { Box, Button, Input } from '@mui/material';
import { useTheme } from '@mui/system';
import { SearchNormal1 } from 'iconsax-react';
import type { ReactElement } from 'react';

import type { FilterType } from '../../../utils/ApiClient';

interface Props {
  filterValue: FilterType;
  onFilterChange: (value: FilterType) => void;
  onFilterClear: () => void;
}

export const StringColumnFilterSearch = ({
  filterValue,
  onFilterChange,
  onFilterClear,
}: Props): ReactElement => {
  const theme = useTheme();
  return (
    <Box display='flex' flexDirection='column' alignItems='center' flexWrap='nowrap'>
      <Input
        value={filterValue}
        onChange={(e) => onFilterChange(e.target.value)}
        fullWidth
        placeholder='Search...'
        startAdornment={
          <SearchNormal1
            variant='TwoTone'
            color={theme.palette.SlabIndigo['700']}
            style={{
              width: '1rem',
              height: '1rem',
              marginRight: '5px',
            }}
          />
        }
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '8px',
          paddingLeft: '8px',
          paddingRight: '8px',
          '&:before': { borderBottom: 'none' },
          '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
          '&:after': { borderBottom: 'none' },
        }}
      />
      <Box display='flex' width='100%' justifyContent='flex-end' mt={1}>
        <Button onClick={onFilterClear} size='small' disabled={filterValue === ''}>
          Clear
        </Button>
      </Box>
    </Box>
  );
};
